/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import { Directionality } from "@angular/cdk/bidi";
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Optional, Output, Renderer2 } from "@angular/core";

import { NzTagComponent } from "ng-zorro-antd/tag";
import { InputBoolean } from "ng-zorro-antd/core/util";
import { UiTagColor, UiTagMode } from "./models/tag.models";

@Component({
  selector: "ui-tag",
  exportAs: "uiTag",
  templateUrl: "./tag.component.html",
})
export class UiTagComponent extends NzTagComponent {
  @Input("uiMode") public nzMode: UiTagMode = "default";
  @Input("uiColor") public nzColor?: UiTagColor;
  @Input("uiChecked") @InputBoolean() public nzChecked = false;
  @Output("uiOnClose") public readonly nzOnClose = new EventEmitter<MouseEvent>();
  @Output("uiCheckedChange") public readonly nzCheckedChange = new EventEmitter<boolean>();

  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  public constructor(cdr: ChangeDetectorRef, renderer: Renderer2, elementRef: ElementRef, @Optional() directionality: Directionality) {
    super(cdr, renderer, elementRef, directionality);
  }
}
